import React from 'react';
import { ContactCard, Theme } from '@palomina/palomina-website/components';
import { NoJs } from '@palomina/palomina-common/components';
import 'modern-normalize/modern-normalize.css';
import '@palomina/palomina-common/styles/global.css';

interface IProps {
  children: React.ReactNode;
  className?: string;
}

// Site is intentionally reduced to a contact-only page; page content
// (Sanity slices, Header, Footer) is not rendered but remains in the
// codebase and CMS so the full site can be restored by reverting this.
const Layout = (_props: IProps) => (
  <>
    <NoJs />
    <Theme />

    <ContactCard />
  </>
);

export default Layout;
